export default "__VITE_ASSET__7a731ee9__"